/* eslint-disable no-lone-blocks */
import axios, { AxiosRequestConfig } from "axios";
import { paths } from "./ServiceConstants.tsx";
import DebugUtils from "../utils/DebugUtils.tsx";

const getBaseURL = (baseURL?: string) => {
  if (baseURL) {
    return baseURL;
  } else {
    return paths.BASE_URL;
  }
};
const ServicesManagerAPICall = {
  request: async (
    methodType: string,
    endpoint: string,
    data?: any,
    hasAuthToken: boolean = true,
    paramAsPathVariable?: any,
    baseURL?: string
  ) => {
    let queryParams: string = "";
    let url: any;
    let authenticationDatum: any;

    if (hasAuthToken) {
      authenticationDatum = localStorage.getItem("AUTH_TOKEN");
    }

    const config: AxiosRequestConfig = {
      method: "",
      url: "",
      headers: hasAuthToken
        ? {
            Authorization: `Bearer ${authenticationDatum ?? ""}`,
            "Content-Type": "application/json",
          }
        : {
            "Content-Type": "application/json",
          },
    };
    try {
      switch (methodType) {
        case "GET":
          if (data) {
            if (paramAsPathVariable) {
              for (const key in data) {
                queryParams += `/${data[key]}`;
              }
              url = `${getBaseURL(baseURL)}${endpoint}${queryParams}`;
            } else {
              const queryParams = new URLSearchParams(data).toString();
              url = `${getBaseURL(baseURL)}${endpoint}?${queryParams}`;
            }
          } else {
            url = `${getBaseURL(baseURL)}${endpoint}`;
          }
          config.method = `${methodType.toLowerCase()}`;
          config.url = url;
          break;

        case "POST":
        case "PUT":
        case "PATCH":
          config.method = `${methodType.toLowerCase()}`;
          config.url = `${getBaseURL(baseURL)}${endpoint}`;
          config.data = data;
          break;
        case "DELETE":
        case "OPTIONS":
          config.method = `${methodType.toLowerCase()}`;
          config.url = `${getBaseURL(baseURL)}${endpoint}`;
          break;
        default:
          throw new Error(`Unsupported method type: ${methodType}`);
      }
      DebugUtils.printState(`config : ${JSON.stringify(config)}`);
      const response = await axios(config);
      DebugUtils.printState(`status : ${JSON.stringify(response.status)}`);
      if (response.status === 200) {
        DebugUtils.successState(
          `responseData : ${JSON.stringify(response.data)}`
        );
        return response.data ?? {};
      }
    } catch (error: any) {
      DebugUtils.errorState(`error : ${error}`);
      if (error.response) {
        // Handle the response error
        DebugUtils.errorState(
          `response error : ${JSON.stringify(error.response.data)}`
        );
        return error.response.data ?? {};
      } else {
        // Handle the generic error message
        DebugUtils.errorState(`message error : ${error.message}`);
        return { message: error.message };
      }
    }
  },
};

export default ServicesManagerAPICall;
